import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-inner" }
const _hoisted_2 = { class: "value-icon" }
const _hoisted_3 = { class: "value-title" }
const _hoisted_4 = { class: "value-desc" }
const _hoisted_5 = {
  key: 0,
  class: "card-action"
}




export default /*@__PURE__*/_defineComponent({
  __name: 'ValueCard',
  props: {
    icon: {},
    title: {},
    description: {},
    actionText: {}
  },
  emits: ["action-click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const handleActionClick = () => {
  emit('action-click')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["value-card", { 'has-action': __props.actionText }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_icon, { name: __props.icon }, null, 8, ["name"])
      ]),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1),
      (__props.actionText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_button, {
              round: "",
              class: "action-button",
              onClick: handleActionClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.actionText) + " ", 1),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  class: "action-arrow"
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})